// extracted by mini-css-extract-plugin
module.exports = {"popupContent":"FVSStep0_popupContent__3WmPL","thick":"FVSStep0_thick__Tj_So","infoDiv":"FVSStep0_infoDiv__pEI3_","icon":"FVSStep0_icon__2JQ0Y","info":"FVSStep0_info__11tuE"};